import React, { useEffect, useRef, useState } from "react";
import BetQLLogo from "../BetQLLogo";
import styles from "./styles.scss";
import { mdiCloseCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useMutation } from "@apollo/client";
import { renderRatingByValue } from "src/services/ValueDataService";
import { CREATE_USER_MUTATION } from "src/gql/mutations";
import { getCxd } from "src/services/CellxpertService";
import AnalyticsService from "src/services/AnalyticsService";
import GAService from "src/services/GAService";
import ClaritasService from "src/services/ClaritasService";
import { useContainerQuery } from "src/services/UtilService";
import FocusedTextLink from "../FocusedTextLink";

const EmailCapture = (props: DivProps) => {
  const [createUser, { loading }] = useMutation(CREATE_USER_MUTATION);
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isVisible, setIsVisible] = useState<boolean | undefined>(false);
  const container = useRef(null);

  useEffect(() => {
    setIsVisible(!window.localStorage.getItem("emailInLocalStorage"));
  }, []);

  const validateEmail = () => {
    let validateError = "";
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      validateError = "Email cannot be empty";
    } else if (trimmedEmail) {
      const regex = /\S+@\S+\.\S+/;
      if (!regex.test(trimmedEmail)) {
        validateError = "Not a valid email address";
      }
    }
    return validateError;
  };

  const saveEmailCapture = () => {
    setIsVisible(false);
    window.localStorage.setItem("emailInLocalStorage", "true");
  };

  const onSubmit = async () => {
    const validateError = validateEmail();

    if (validateError) {
      return setError(validateError);
    }

    try {
      setError("");
      const { data } = await createUser({
        variables: {
          cxd: getCxd(),
          email,
          emailOnly: true,
        },
      });
      if (data?.createUser?.token) {
        GAService.sendEvent({
          hitType: "event",
          eventCategory: "Email Capture - Success",
          eventAction: window.location.href,
          eventLabel: "Email Capture - Submission Form",
        });
        AnalyticsService.track("Email Capture - Success", {
          page: window.location.href,
        });
        ClaritasService.trackEmailCapture();

        saveEmailCapture();
      } else {
        GAService.sendEvent({
          hitType: "event",
          eventCategory: "Email Capture - Fail",
          eventAction: window.location.href,
          eventLabel: "Email Capture - Submission Form",
        });
        AnalyticsService.track("Email Capture - Fail", {
          page: window.location.href,
          message: "No response data",
        });
      }
    } catch (err: any) {
      const message = err?.graphQLErrors?.[0]?.message;
      setError(message);

      if (message) {
        GAService.sendEvent({
          hitType: "event",
          eventCategory: "Email Capture - Fail",
          eventAction: window.location.href,
          eventLabel: "Email Capture - Submission Form",
        });
        AnalyticsService.track("Email Capture - Fail", {
          page: window.location.href,
          message,
        });
      }
    }
  };

  useContainerQuery(container, {
    small: 500,
    medium: 850,
    large: Infinity,
  });

  if (!isVisible) {
    return <div ref={container} />;
  }

  return (
    <div className="email-capture" ref={container} {...props}>
      <div className="email-capture-left">
        <div className="email-capture-stars">{renderRatingByValue(5)}</div>
        <BetQLLogo color="white" className="betql-logo" />
      </div>

      <form className="email-capture-form">
        <div className="email-capture-input-container">
          <input
            className="email-capture-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="email-capture-submit" type="button" onClick={onSubmit} disabled={loading}>
            Subscribe Now
          </button>
        </div>

        <p className="email-capture-error">{error}</p>
      </form>

      <div className="email-capture-right">
        <div className="square-icon">
          <div className="square-inner">
            <div className="square-inner-inner" />
          </div>
        </div>
        <div className="email-capture-text-container">
          <div className="email-capture-text">GET DAILY PICKS EMAILED TO YOU</div>
        </div>

        <FocusedTextLink className="email-capture-close-icon-right" onClick={saveEmailCapture}>
          <Icon path={mdiCloseCircleOutline} size="22px" color="black" />
        </FocusedTextLink>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default EmailCapture;
